import axios from "axios";
import { getAuthToken } from "../utils/getAuthToken";

const SERVER = process.env.REACT_APP_SERVER_DOMAIN || "http://localhost:8000";

export const WHATSAPP_WEB_MEDIA_TYPES = ["image", "video", "document", "audio"];
// Mirrors MAX_CAPTION_LENGTH in server/services/whatsappWeb/whatsappWebMedia.service.js
export const WHATSAPP_WEB_MAX_CAPTION_LENGTH = 1024;

/**
 * POST /api/workspaces/:id/whatsapp-web/contacts/:contactId/media: an agent's file into the contact's open WhatsApp Web chat.
 * Nothing goes to WhatsApp, so none of the Meta upload paths are involved. The server checks the file's type and bytes itself; a
 * Blob without a name (a voice recording) is given one so its extension can be judged.
 * Rejects with an Error whose message is the server's reason, ready to show.
 */
export async function sendWhatsappWebMedia({ workspaceId, contactId, file, tempId, caption, durationSeconds }) {
  if (!(file instanceof Blob)) {
    throw new Error("WhatsApp Webchats take files from your device. Choose a file instead of a library item.");
  }
  const token = await getAuthToken();
  const form = new FormData();
  form.append("file", file, file.name || "voice-note.webm");
  form.append("tempId", tempId);
  if (caption) form.append("caption", caption);
  if (durationSeconds != null) form.append("durationSeconds", String(durationSeconds));
  try {
    const res = await axios.post(`${SERVER}/api/workspaces/${workspaceId}/whatsapp-web/contacts/${contactId}/media`, form, {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 120000,
    });
    return res.data;
  } catch (err) {
    throw new Error(err?.response?.data?.message || "Could not send the file to the WhatsApp Webchat.");
  }
}
